module.exports = __webpack_public_path__ + "img/login-image.7e734987.png";